var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.enableSearch)?_c('b-input',{attrs:{"type":"text"},model:{value:(_vm.searchKey),callback:function ($$v) {_vm.searchKey=$$v},expression:"searchKey"}}):_vm._e(),_c('ul',{staticClass:"ztree card",attrs:{"id":_vm.treeId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }